import { byMedia } from '../helpers/media';
import { getPx } from '../helpers/common';
export var fontSize = byMedia(function (value) {
  return "font-size: " + getPx(value) + ";";
});